/**
 * Created by chenqifeng on 2016/8/31.
 */
import maple                                from 'maple';
import * as api                             from '../api/index';
import {setCookie, getCookie, removeCookie} from '../util/cookie';
import weChat                               from '../weChat';
import app                                  from '../app/index';

let checkLoginRun = function(deferred, isWcAutoLogin){
        // 微信下，并且需要自动登录
        if( maple.device.weixin
            && isWcAutoLogin
            && tgSession('autoLogin') !== 'true'
            && sessionStorage.getItem('wxLogout') !== 'true'
            && getCookie('isLogin') !== 'true' ){

            autoLogin( deferred );
        }
        else{
            getUserInfo( deferred );
        }
    }
    /**
     * 微信自动登录
     * 获取到 openId，调用微信的登录接口
     * */
    , autoLogin = function(deferred){
        // 获取 openId 和 cypher
        weChat.getOpenidUtil({
            success: function(openId, openIdCypher, code){
                if( code ){
                    wcLogin(openId, openIdCypher, code, deferred);
                    tgSession('autoLogin', 'true');
                }
                else{
                    wcLoginCallback( deferred );
                }
            }
            , fail: function(){
                getUserInfo( deferred );
                tgSession('autoLogin', 'true');
            }
            , always: function(){

            }
        });
    }
    , tgSession = function(){
        let cookie = maple.cookie
            , isApp = cookie('global') === 'ios' || cookie('global') === 'android'
            , sessionSetFn = isApp ? cookie.bind( maple ) : sessionStorage.setItem.bind( sessionStorage )
            , sessionGetFn = isApp ? cookie.bind( maple ) : sessionStorage.getItem.bind( sessionStorage )
            ;

        if( arguments.length >= 2 ){
            return sessionSetFn(arguments[0], arguments[1]);
        }
        else{
            return sessionGetFn( arguments[0] );
        }
    }
    , wcLogin = function(openid, openid_cypher, code, deferred){
        api.member.weChatLogin({
            type: 'POST'
            , data: {
                unionId: weChat.getUnionId()
                , code
            }
            , success: function(data){
                setCookie('token', data.token, '7d');
                setCookie('vip', +data.isVip, '7d');
                localStorage.removeItem('ssoConfirmed');
                wcLoginCallback(deferred, data.token);
            }
            , tgError: function(data){
                data = data || {};
                if( data.code === 503 ){
                    location.reload();
                }
                else{
                    wcLoginCallback(deferred);
                }
            }
            , error: function(){
                wcLoginCallback(deferred);
            }
        });
    }
    , wcLoginCallback = function(deferred, token){
        if( tgSession('isCheck') === 'true' ){
            deferred.resolve();
        }
        else{
            api.member.memberInfo({
                type: 'GET'
                , data: {
                    token: token
                }
                , isCheckLogin: false
                , tgError: function(responseData){
                    if( responseData.code === 888 ){
                        removeCookie('token');
                        removeCookie('isLogin');
                        removeCookie('validate');
                        removeCookie('memberId');
                        removeCookie('cellPhone');
                        removeCookie('username');
                        removeCookie('nickName');
                        // setCookie('isLogin',false);
                        tgSession('isCheck', true);
                    }

                    deferred.resolve();
                },
                error: function(){
                    removeCookie('token');
                    removeCookie('isLogin');
                    removeCookie('validate');
                    removeCookie('memberId');
                    removeCookie('cellPhone');
                    removeCookie('username');
                    removeCookie('nickName');
                    // setCookie('isLogin',false);
                    tgSession('isCheck', true);
                    deferred.resolve();
                },
                success: function(data){
                    let memberId = data.id
                        , nickName = data.nickName
                        , cellPhone = data.cellPhone
                        , name = nickName || cellPhone
                        , validate = data.validate || 0
                        ;

                    setCookie('memberId', memberId, '7d');
                    setCookie('cellPhone', cellPhone, '7d');
                    setCookie('username', name, '7d');
                    setCookie('isLogin', true, '7d');
                    setCookie('validate', validate, '7d');
                    setCookie('nickName', nickName, '7d');
                    tgSession('isCheck', true);
                    deferred.resolve();
                }
            });
        }
    }
    /**
 * 获取用户基本信息
 * 校验登录状态
 */
    , getUserInfo = function(deferred){
        if( tgSession('isCheck') === 'true' ){
            queryVersionDate();
            deferred.resolve();
        }
        else{
            api.member.memberInfo({
                type: 'GET'
                , isCheckLogin: false
                , tgError: function(responseData){
                    if( responseData.code === 888 ){
                        removeCookie('token');
                        removeCookie('isLogin');
                        removeCookie('validate');
                        removeCookie('memberId');
                        removeCookie('cellPhone');
                        removeCookie('username');
                        removeCookie('nickName');
                        setCookie('isLogin', false);
                        tgSession('isCheck', true);
                    }

                    deferred.resolve();
                }
                , error: function(){
                    removeCookie('token');
                    removeCookie('isLogin');
                    removeCookie('validate');
                    removeCookie('memberId');
                    removeCookie('cellPhone');
                    removeCookie('username');
                    removeCookie('nickName');
                    setCookie('isLogin', false);
                    tgSession('isCheck', true);
                    deferred.resolve();
                }
                , success: function(data){
                    let memberId = data.id
                        , nickName = data.nickName
                        , cellPhone = data.cellPhone
                        , name = nickName || cellPhone
                        , validate = data.validate || 0
                        ;

                    setCookie('memberId', memberId, '7d');
                    setCookie('cellPhone', cellPhone, '7d');
                    setCookie('username', name, '7d');
                    setCookie('isLogin', true, '7d');
                    setCookie('validate', 1, '7d');
                    setCookie('nickName', nickName, '7d');
                    tgSession('isCheck', true);
                    // 查询版本时间并处理
                    queryVersionDate();

                    deferred.resolve();
                }
            });
        }
    }
    , // 查询版本时间并处理
    queryVersionDate = function () {
        if (getCookie('isLogin') !== 'true') {
            return;
        }
        if (getCookie('versionDate')) {
            return;
        }
        api.base.queryVersionDate({
            data: {
                merchantId: 1
            }
        }).then((data) => {
            let localVersionDate = localStorage.getItem('TG-VersionDate');
            if (localVersionDate != data.data) {
                let contentTpl = `
                    <div>
                        <div style="text-align:center;font-size:20px;color:#000000;font-weight:500;">协议更新</div>
                        <p style="font-size: 14px;color: #353535;margin:16px 4px 22px;">亲爱的用户，为了保障您的权益，请仔细阅读<a href="/login/terms.html" style="color: #3370FF;">《使用条款》</a>和<a href="/login/protectionProtocol.html" style="color: #3370FF;">《隐私保护政策》</a>中的条款。点击同意即表示您已阅读并接受协议内容。</p>
                    </div>
                    <style>
                        .popup {
                            border-radius: 12px !important;
                            min-width: 320px !important;
                            padding-bottom: 64px !important;
                        }
                        .popup_ok, .popup_cancel {
                            height: 64px;
                        }
                        .confirm_cancel {
                            border-right: none !important;
                        }
                    </style>
                `;
                maple.confirm({
                    content:contentTpl,
                    okText:'<div class="text-center" style="height:40px;width:120px;background-color:#FF2238;border-radius:20px;line-height:40px;color:#fff;">同意</div>',
                    okFn:() => {
                        localStorage.setItem('TG-VersionDate', data.data);
                        tgSession('isCheck', true);
                        setCookie('versionDate', data.data, '1d');
                    },
                    cancelText:'<div class="text-center" style="height:40px;width:120px;border-radius:20px;line-height:40px;color:#FF2238;border:1px solid #FF2238;margin: 0 0 0 auto;">不同意</div>',
                    cancelFn: () => {
                        api.member.logout({}).then(_ => {
                            //session中追加退出登录标志位
                            maple.device.weixin && sessionStorage.setItem('wxLogout', true);
                            app.tgLogout();
                            removeCookie('token');
                            removeCookie('memberId');
                            removeCookie('cellPhone');
                            removeCookie('username');
                            removeCookie('isLogin');
                            removeCookie('validate');
                            removeCookie('vip');
                            location.reload();
                        });
                    }
                })
            }
        });
    }
    ;

export {checkLoginRun};